import { Navigate, Route, Routes } from 'react-router';
import { useAuth } from '@/auth/AuthContext';
import { AppShell } from '@/components/AppShell';
import { FullPageLoading } from '@/components/ui';
import { ChangePasswordPage } from '@/pages/ChangePasswordPage';
import { AlertsPage } from '@/pages/AlertsPage';
import { ClientesPage } from '@/pages/ClientesPage';
import { CrmReportPage } from '@/pages/CrmReportPage';
import { LeadPage } from '@/pages/LeadPage';
import { OriginLinksPage } from '@/pages/OriginLinksPage';
import { ClosingsPage } from '@/pages/ClosingsPage';
import { GoalsPage } from '@/pages/GoalsPage';
import { IntegrationsPage } from '@/pages/IntegrationsPage';
import { SaleCostPage } from '@/pages/SaleCostPage';
import { SimulatorPage } from '@/pages/SimulatorPage';
import { PagamentosPage } from '@/pages/PagamentosPage';
import { ProximosVoosPage } from '@/pages/ProximosVoosPage';
import { SalesPage } from '@/pages/SalesPage';
import { TeamDashboard } from '@/pages/TeamDashboard';
import { VendorDashboard } from '@/pages/VendorDashboard';
import { LoginPage } from '@/pages/LoginPage';
import { MfaPage } from '@/pages/MfaPage';
import { SetupPage } from '@/pages/SetupPage';
import { UsersPage } from '@/pages/UsersPage';

/**
 * O que a pessoa vê depende da etapa do acesso. A API decide a etapa
 * (/auth/me); a tela só obedece. Mesmo que alguém force uma URL, a API
 * recusa as chamadas sem login completo.
 */
export function App() {
  const { state } = useAuth();

  if (state.status === 'loading') return <FullPageLoading />;
  if (state.status === 'setup') return <SetupPage />;
  if (state.status === 'anonymous') return <LoginPage />;

  switch (state.stage) {
    case 'MFA_SETUP':
      return <MfaPage mode="setup" />;
    case 'MFA_VERIFY':
      return <MfaPage mode="verify" />;
    case 'CHANGE_PASSWORD':
      return <ChangePasswordPage required />;
    case 'OK': {
      const gestao = state.user.role === 'ADMIN' || state.user.role === 'GESTOR';
      return (
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={gestao ? <TeamDashboard /> : <VendorDashboard />} />
            {gestao && state.user.vendedor && <Route path="meu-desempenho" element={<VendorDashboard />} />}
            <Route path="vendas" element={<SalesPage />} />
            <Route path="vendas/:id" element={<SaleCostPage />} />
            <Route path="fechamentos" element={<ClosingsPage />} />
            <Route path="simulador" element={<SimulatorPage />} />
            <Route path="links-de-pagamento" element={<PagamentosPage />} />
            <Route path="proximos-voos" element={<ProximosVoosPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="clientes/:id" element={<LeadPage />} />
            {gestao && <Route path="relatorio-clientes" element={<CrmReportPage />} />}
            {gestao && <Route path="links-de-origem" element={<OriginLinksPage />} />}
            {gestao && <Route path="alertas" element={<AlertsPage />} />}
            {gestao && <Route path="metas" element={<GoalsPage />} />}
            <Route path="minha-senha" element={<ChangePasswordPage required={false} />} />
            {state.user.role === 'ADMIN' && <Route path="usuarios" element={<UsersPage />} />}
            {state.user.role === 'ADMIN' && <Route path="integracoes" element={<IntegrationsPage />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      );
    }
    default:
      return <FullPageLoading />;
  }
}
